import { useTranslation } from "react-i18next";
import { PageHeader, PrimaryLink, Disclaimer } from "../components/ui-blocks";

export default function Services() {
  const { t } = useTranslation();
  const services = t("data.services", { returnObjects: true });

  return (
    <>
      <PageHeader
        testId="services-header"
        overline={t("services.headerOverline")}
        title={t("services.headerTitle")}
        lead={t("services.headerLead")}
      />

      <section className="section-pad" data-testid="services-grid">
        <div className="container-mtbl">
          <div className="grid md:grid-cols-2 gap-6">
            {services.map((s, i) => (
              <div
                key={s.title}
                data-testid={`services-item-${i}`}
                className="card-soft p-10 md:p-12"
              >
                <p className="overline">
                  {t("services.itemLabel")} · 0{i + 1}
                </p>
                <h2 className="mt-4 text-[#0B1A3D] text-2xl md:text-3xl font-semibold tracking-tight">
                  {s.title}
                </h2>
                <p className="mt-5 text-slate-600 leading-relaxed text-base md:text-lg">
                  {s.body}
                </p>
              </div>
            ))}
          </div>

          <Disclaimer testId="services-disclaimer">
            {t("services.disclaimer")}
          </Disclaimer>
        </div>
      </section>

      <section
        data-testid="services-cta"
        className="bg-paper border-t border-slate-200"
      >
        <div className="container-mtbl py-20 md:py-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <h3 className="text-[#0B1A3D] text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight max-w-2xl">
            {t("services.ctaTitle")}
          </h3>
          <PrimaryLink to="/contact" testId="services-cta-contact">
            {t("common.startConversation")}
          </PrimaryLink>
        </div>
      </section>
    </>
  );
}
